import React from 'react'
import { useSelector } from 'react-redux'
import Button, { TYPES as BUTTON_TYPES } from 'components/Button'
import { selectStaticTextByKey } from 'services/static-text/selectors'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'
import { URL_ACCOUNT_PAUSE } from 'services/url/constants'
import { scrollToTop } from 'services/dom'

/**
 * Cancel modal for the price increase
 * @returns {JSX.Element} Cancel modal
 */
function MyAccountCancelModal (props) {
  const { url } = props
  const staticText = useSelector(selectStaticTextByKey('myAccountCancelModal'))

  const title = staticText.get('defaultTitle')
  const subtitle = staticText.get('defaultSubtitle')

  return (
    <div className="my-account-cancel-modal">
      <div className="my-account-cancel-modal__title">{title}</div>
      <div className="my-account-cancel-modal__subtitle">{subtitle}</div>
      <div className="my-account-cancel-modal__line"></div>
      <div className="my-account-cancel-modal__buttons">
        <Button
          url={URL_ACCOUNT_PAUSE}
          onClick={scrollToTop}
          type={BUTTON_TYPES.PRIMARY}
          className="my-account-cancel-modal__keep-button"
        >
          {staticText.get('pauseButton')}
        </Button>
        <Button
          url={url}
          onClick={scrollToTop}
          type={BUTTON_TYPES.SECONDARY}
          className="my-account-cancel-modal__cancel-button"
        >
          <div>
            {staticText.get('cancelButton')}
            <IconV2
              className="my-account-cancel-modal__cancel-button-icon"
              type={ICON_TYPES.CHEVRON_RIGHT}
            />
          </div>
        </Button>
      </div>
    </div>
  )
}

export default MyAccountCancelModal
